import { Observable} from "rxjs";
import {IServiceResponse} from "../../../../services/external-api/response-interfaces";
import {map} from "rxjs/operators";
import {DataService} from "../../../../services/external-api/data.service";
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";
export type DataSetWorkMode = 'page' | 'list';
export interface IDataSet<T> {
  dataSet: Array<T>;
  rawDataSet: Array<T>;
  next: boolean;
  limit: number;
  offset: number;
  allDataFetched: boolean;
}

type RdfDataFnc = (service: DataService, offset: number, limit: number, searchStr: string, param: object, configurationManager: ConfigurationManager) =>Observable<IServiceResponse>;
type RdfMapFnc<T> = (item: object) => T;

/**
 * Класс для работы с паджинированными данными на сервере. Позволяет осуществлять поиск на сервере (если сервис поддерживает), сдвигаться вперед и назад
 */
export class RdfDataSet<T> {
  currentOffset = 0;
  searchStr = '';


  dataSet: IDataSet<T> = undefined;

  constructor(
    private dataService: DataService,
    private configurationManager: ConfigurationManager,
    private dataFunc:RdfDataFnc,
    private mapFunc:RdfMapFnc<T>,
    private workMode: DataSetWorkMode = 'page',
    private limit = 100,
    private dataSourceParam = {},



  ) {
    this.currentOffset = 0;
  }

  /**
   * Получить данные с сервера
   * @param searchStr - строка поиска
   * @param offset - смещение
   */
  fetch(searchStr: string ='', offset?:number ):Observable<IDataSet<T>>{
    if (offset!==undefined && offset!== null) {
      this.currentOffset = offset;
    }
    this.searchStr = searchStr;
    return this.dataFunc(this.dataService, this.currentOffset,this.limit,searchStr, this.dataSourceParam, this.configurationManager).pipe(
      map(t=>{
        if (!this.dataSet) {
          this.dataSet = {
            dataSet: t.report.map(data => this.mapFunc(data)),
            rawDataSet: t.report.map(data => this.mapFunc(data)),
            next: t.Next ? t.Next : false,
            limit: t.Limit !== null && t.Limit !== undefined ? t.Limit : this.limit,
            offset: t.Offset !== null && t.Offset !== undefined ? t.Offset : this.currentOffset,
            allDataFetched: false
          };
        }else {
          this.dataSet.rawDataSet = t.report.map(data => this.mapFunc(data));
          this.dataSet.next = t.Next ? t.Next : false;
          this.dataSet.limit = t.Limit !== null && t.Limit !== undefined ? t.Limit : this.limit;
          this.dataSet.offset = t.Offset !== null && t.Offset !== undefined ? t.Offset : this.currentOffset;
          this.dataSet.allDataFetched = false;
        }
        if (this.dataSet.offset ===0 && this.dataSet.next === true && this.dataSet.rawDataSet.length>=this.dataSet.offset + this.limit) {
          // сервис вернул все данные
          this.dataSet.allDataFetched = true;
        }
        this.dataSet.rawDataSet = t.report.map(data=>this.mapFunc(data));
        switch (this.workMode) {
          case "page":
            this.dataSet.dataSet = t.report.map(data => this.mapFunc(data));
            break;
          case "list":
            this.dataSet.dataSet = this.dataSet.dataSet.slice(0, this.dataSet.offset);
            this.dataSet.dataSet = this.dataSet.dataSet.concat(this.dataSet.rawDataSet);
            break;
        }
        //todo: Добавить возможность работы с данными, когда сервис не умеет паджинировать данные
        return this.dataSet;
      })
    );
  }

  /**
   * Сдвинуться вперед
   */
  next(): Observable<IDataSet<T>>{
    if (!this.dataSet) {
      //Если датасет пуст - то это вообще странно, но так вполне можно поэтому при пустом датасете мы сбрасываем offset и всегда делаем fetch
      this.currentOffset = 0;
      return this.fetch(this.searchStr);
    } else {
      if (this.dataSet.next) {
      //if (this.currentOffset+ this.limit<this.dataSet.rawDataSet.length && this.dataSet.next) {
        this.currentOffset += this.limit;
      }
      return this.fetch(this.searchStr);
    }
  }

  /**
   * Сдвинуться назад
   */
  prev(): Observable<IDataSet<T>>{
    this.currentOffset -=this.limit;
    if (this.currentOffset<0) {
      //меньше 0 нельзя
      this.currentOffset = 0;
    }
    if (!this.dataSet) {
      //Если датасет пуст - то это вообще странно, но так вполне можно поэтому при пустом датасете мы сбрасываем offset и всегда делаем fetch
      this.currentOffset = 0;
      return this.fetch(this.searchStr);
    } else {
      return this.fetch(this.searchStr);
    }
  }


}
